import { render } from "./GlobalEvent.vue?vue&type=template&id=9b417a0a&ts=true"
import script from "./GlobalEvent.vue?vue&type=script&lang=ts"
export * from "./GlobalEvent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__